export default function() {
    let scrollpos = (window.scrollY ? window.scrollY : window.pageYOffset);
    const header = document.querySelector("header");
    const header_height = header.offsetHeight;

    const add_class_on_scroll = () => header.classList.add("is-scrolled");
    const remove_class_on_scroll = () => header.classList.remove("is-scrolled");

    if (scrollpos >= 60) {
      add_class_on_scroll();
    } else {
      remove_class_on_scroll();
    }

    window.addEventListener('scroll', function() {
        scrollpos = (window.scrollY ? window.scrollY : window.pageYOffset);

        if (scrollpos >= 60) {
          add_class_on_scroll();
        } else {
          remove_class_on_scroll();
        }
    });

    let isLightLogo = false;
    const menuLogo = document.querySelector('.logo');
    const menuTrigger = document.querySelector('.res-menu-trigger');
    const toggleMenu = document.querySelector('.toggleMenu');

    menuTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        if(toggleMenu.classList.contains('is-active')) {
            toggleMenu.classList.remove('is-active');
            menuTrigger.classList.remove('is-active');
            header.classList.remove('menu-active');

            if(!isLightLogo) {
                menuLogo.classList.remove('light2');
            }
        } else {
            toggleMenu.classList.add('is-active');
            menuTrigger.classList.add('is-active');
            header.classList.add('menu-active');

            if(menuLogo.classList.contains('light2')) {
                isLightLogo = true;
            } else {
                menuLogo.classList.add('light2');
            }
        }
    }, false);

    /*const careerMenuTrigger = document.querySelector('.toggleMenu .menu-item.menu-item-has-children > a');
    careerMenuTrigger.addEventListener('click', (e) => {
        e.preventDefault();

        if(careerMenuTrigger.classList.contains('is-active')) {
            careerMenuTrigger.classList.remove('is-active');
            careerMenuTrigger.nextElementSibling.classList.remove('is-active');
        } else {
            careerMenuTrigger.classList.add('is-active');
            careerMenuTrigger.nextElementSibling.classList.add('is-active');
        }
    }, false);*/
}
